import type { SVGProps } from 'react';

const SvgFile05Sm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.334 1.513v2.754c0 .373 0 .56.072.703a.67.67 0 0 0 .292.29c.142.074.329.074.702.074h2.754m-3.82 6h-4m5.333-2.667H5.334m8-2.008v4.808c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H5.867c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.534c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.875c.428-.218.988-.218 2.108-.218h2.141c.49 0 .734 0 .964.056a2 2 0 0 1 .578.24c.202.123.375.296.72.642l2.126 2.125c.346.346.52.52.643.72q.165.271.24.579c.055.23.055.475.055.964"
    />
  </svg>
);
export default SvgFile05Sm;
